import api from "../config/api";
import type { ApiResponse, PaginatedResponse, Receipt } from "../types";


export interface CreateReceiptRequest {
  customer: string;
  currency: 'LAK' | 'THB' | 'USD';
  paymentMethod: 'cash' | 'transfer' | 'qr' | 'card';
  items: {
    course: string;
    packageOption: {
      sessions: number;
      price: {
        LAK: number;
        THB: number;
        USD: number;
      };
    };
    quantity: number;
  }[];
  discount?: number;
  notes?: string;
}

export const receiptService = {
  getReceipts: async (params: any = {}): Promise<PaginatedResponse<Receipt>> => {
    const response = await api.get('/receipts', { params });
    return response.data;
  },

  getReceipt: async (id: string): Promise<ApiResponse<Receipt>> => {
    const response = await api.get(`/receipts/${id}`);
    return response.data;
  },

  createReceipt: async (data: CreateReceiptRequest): Promise<ApiResponse<Receipt>> => {
    const response = await api.post('/receipts', data);
    return response.data;
  },

  updateReceipt: async (id: string, data: { amountPaid: number; paymentMethod?: string; notes?: string }): Promise<ApiResponse<Receipt>> => {
    const response = await api.put(`/receipts/${id}`, data);
    return response.data;
  },

  voidReceipt: async (id: string, reason: string): Promise<ApiResponse<Receipt>> => {
    const response = await api.put(`/receipts/${id}/void`, { voidReason: reason });
    return response.data;
  },

  getDailyReceipts: async (date: string): Promise<ApiResponse<any>> => {
    const response = await api.get(`/receipts/daily/${date}`);
    return response.data;
  },
};
